import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@utils';
import { AlertTriangle, CircleCheck, CircleX, InfoIcon, Lightbulb } from 'lucide-react';

const alertVariants = cva('inline-flex items-center rounded-sm p-md font-normal w-full bg-background  text-grey-100', {
  variants: {
    variant: {
      info: 'bg-secondary-background',
      success: 'bg-success-background',
      error: 'bg-error-background',
      warning: 'bg-warning-background',
      idea: 'bg-secondary-background',
    },
  },
  defaultVariants: {
    variant: 'info',
  },
});

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof alertVariants> {}

function Alert({ className, variant, children, ...props }: AlertProps): React.JSX.Element {
  const iconSize = 24;
  return (
    <div className={cn(alertVariants({ variant }), className)} {...props}>
      {variant === 'info' && <InfoIcon size={iconSize} />}
      {variant === 'error' && <CircleX className="text-error-primary" size={iconSize} />}
      {variant === 'warning' && <AlertTriangle className="text-warning-primary" size={iconSize} />}
      {variant === 'success' && <CircleCheck className="text-success-primary" size={iconSize} />}
      {variant === 'idea' && <Lightbulb size={iconSize} />}
      <span className="ml-md flex-1">{children}</span>
    </div>
  );
}

export { Alert, alertVariants };
